<template>
  <div>
    <b-container>
      <b-row class="m-0">
        <b-col md="1" />
        <b-col
          lg="10"
          class="d-flex align-items-center justify-content-center px-2 p-lg-5"
        >
          <b-col
            sm="10"
            md="8"
            lg="9"
            class="px-xl-2 mx-auto"
          >
            <b-form
              class="chat-app-form"
              @submit.prevent="sendRole"
            >
              <validation-observer
                ref="roleForm"
                #default="{invalid}"
                class="w-100"
              >
                <p class="h5">
                  Role Name *
                </p>
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge form-send-message mr-1"
                  >
                    <b-form-input
                      v-model="form.name"
                      placeholder="Enter new role name"
                    />
                  </b-input-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </validation-observer>
              <b-row
                class="w-100 d-flex align-items-center justify-content-center p-0 py-50"
              >
                <b-button
                  variant="primary"
                  class="mt-2"
                  type="submit"
                >
                  Save
                </b-button>
              </b-row>
            </b-form>

          </b-col>
        </b-col>
        <b-col md="1" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardText,
  BButton,
  BLink,
  BListGroup,
  BListGroupItem,
  BCardTitle,
  BCardBody,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardText,
    BButton,
    BLink,
    BListGroup,
    BListGroupItem,
    BCardTitle,
    BCardBody,
    BFormGroup,
    BInputGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    required,
    BForm,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        name: null,
      },
    }
  },
  methods: {
    sendRole() {
      this.$refs.roleForm.validate().then(success => {
        if (success) {
          const payload = { query: this.form }
          this.$store.dispatch('users/addRole', payload).then(res => {
            this.$router.push({ name: 'roles' })
            this.$swal({
              icon: 'success',
              title: '<h4>Role Added Successfully</h4>',
              showConfirmButton: true,
              confirmButtonColor: '#7367f0',
              allowOutsideClick: true,
            })
          }).catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: `<h4>${error.response.data.error}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            }
          })
        }
      })
    },
  },
}
</script>
<style>

input, .vs__selected{
  color: #fff !important;
}

p{
  color: #ffffffe6 !important;
}

input::placeholder{
  color: #5e5873 !important;
}
</style>
